import * as angular from 'angular';
import * as _ from 'lodash';

import { ActualDataType, ComponentDefinition, ConnectionPoint, Dictionary, DigitalSet, IValueViewModel, Pattern, TagDefinition, Unit, VariableType } from '../../models';

class TagSearchBarController implements angular.IComponentController {
    connectionPoints: Dictionary<ConnectionPoint>;
    criteria: Pattern<TagDefinition>[];
    digitalSets: Dictionary<DigitalSet>;
    filtered: TagDefinition[];
    tags: TagDefinition[];
    units: Dictionary<Unit>;
    variableTypes: Dictionary<VariableType>;
    valueViewModels: Dictionary<IValueViewModel>;
    
    private _groupNamesByTag: Dictionary<string[]>;
    private _identifierNamesByTag: Dictionary<string[]>;

    static $inject = [];

    constructor() {
        this.criteria = [
            {
                model: 't',
                label: 'Tag name',
                placeholder: 'Name of the tag',
                property: 't',
                isMatch: (t, r) => r.test(t.name)
            }, {
                model: 'i',
                label: 'Identifier name',
                placeholder: 'Name of the identifier',
                property: 'i',
                isMatch: (t, r) => _.some(this._identifierNamesByTag[t.guid], name => r.test(name))
            }, {
                model: 'g',
                label: 'Group',
                placeholder: 'Search pattern on group',
                property: 'g',
                isMatch: (t, r) => _.some(this._groupNamesByTag[t.guid], name => r.test(name))
            }, {
                model: 'u',
                label: 'Unit',
                placeholder: 'Search pattern on unit (e.g. bar, °C)',
                property: 'u',
                isMatch: (t, r) => {
                    let result = false;
                    if (t.actualDataType === ActualDataType.Float) {
                        result = r.test(this.units[t.unitGuid]?.name);
                    } else if (t.actualDataType === ActualDataType.Digital) {
                        result = r.test(this.digitalSets[t.digitalSetGuid]?.name);
                    }
                    return result;
                }
            }, {
                model: 'c',
                label: 'Comment',
                placeholder: 'Search pattern on comment',
                property: 'c',
                isMatch: (t, r) => r.test(t.shortComment) || r.test(t.longComment)
            }, {
                model: 'variable',
                label: 'Variable',
                placeholder: 'Search pattern on variable type (e.g. pressure, temperature)',
                property: 'v',
                isMatch: (t, r) => r.test(this.variableTypes[t.variableTypeGuid]?.name)
            }, {
                model: 'so',
                label: 'Source',
                placeholder: 'Search pattern on connection point name',
                property: 'so',
                isMatch: (t, r) => r.test(this.connectionPoints[t.acquisitionPointGuid]?.name)
            }
        ];
    }

    $onInit() {
       this.rebuildIndexes();
    }

    $onChanges(_changes: angular.IOnChangesObject) {
       this.rebuildIndexes();
    }

    // Prebuild name index for group and identifier to ease search
    private rebuildIndexes() {
        if (this.valueViewModels && this.tags ) {
            const groupNamesByTag = {};
            const identifierNamesByTag = {};

            this.tags.forEach(t => {            
                identifierNamesByTag[t.guid] = this.valueViewModels[t.guid].identifierNames;  
                groupNamesByTag[t.guid] = this.valueViewModels[t.guid].groupList.map(g => g.name);
            });

            this._groupNamesByTag = groupNamesByTag;
            this._identifierNamesByTag = identifierNamesByTag;
        }
    }
}

export const wtTagSearchBar: ComponentDefinition = {
    componentId: 'wtTagSearchBar',
    controller: TagSearchBarController,
    template: require('./tagSearchBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        connectionPoints: '<',
        digitalSets: '<',     
        filtered: '=',
        tags: '<',
        units: '<',
        variableTypes: '<',
        valueViewModels: '<'
    }
};